/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OdbFormularyDrug
 */
export interface OdbFormularyDrug {
    /**
     * Drug Identification Number (8 digits)
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    din: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    product_name: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    generic_name: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    strength?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    dosage_form?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    manufacturer_code?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    manufacturer_name?: string;
    /**
     * Individual unit price
     * @type {number}
     * @memberof OdbFormularyDrug
     */
    individual_price?: number;
    /**
     * Amount MOHLTC pays per unit
     * @type {number}
     * @memberof OdbFormularyDrug
     */
    amount_mohltc_pays?: number;
    /**
     * Effective drug benefit price (uses amount_mohltc_pays if available, otherwise individual_price)
     * @type {number}
     * @memberof OdbFormularyDrug
     */
    drug_benefit_price?: number;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    coverage_status?: OdbFormularyDrugCoverageStatusEnum;
    /**
     * Limited Coverage Code ID
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    lcc_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    listing_date?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    category_code?: string;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    category_name?: string;
    /**
     * 
     * @type {number}
     * @memberof OdbFormularyDrug
     */
    daily_cost?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OdbFormularyDrug
     */
    not_a_benefit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OdbFormularyDrug
     */
    sec3b?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OdbFormularyDrug
     */
    sec3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OdbFormularyDrug
     */
    sec3b_eap?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OdbFormularyDrug
     */
    sec6?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OdbFormularyDrug
     */
    sec12?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OdbFormularyDrug
     */
    din_status?: string;
    /**
     * 
     * @type {number}
     * @memberof OdbFormularyDrug
     */
    last_updated?: number;
}


/**
 * @export
 */
export const OdbFormularyDrugCoverageStatusEnum = {
    Covered: 'Covered',
    LimitedUse: 'LimitedUse',
    NotCovered: 'NotCovered'
} as const;
export type OdbFormularyDrugCoverageStatusEnum = typeof OdbFormularyDrugCoverageStatusEnum[keyof typeof OdbFormularyDrugCoverageStatusEnum];


/**
 * Check if a given object implements the OdbFormularyDrug interface.
 */
export function instanceOfOdbFormularyDrug(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "din" in value;
    isInstance = isInstance && "product_name" in value;
    isInstance = isInstance && "generic_name" in value;

    return isInstance;
}

export function OdbFormularyDrugFromJSON(json: any): OdbFormularyDrug {
    return OdbFormularyDrugFromJSONTyped(json, false);
}

export function OdbFormularyDrugFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdbFormularyDrug {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'din': json['din'],
        'product_name': json['product_name'],
        'generic_name': json['generic_name'],
        'strength': !exists(json, 'strength') ? undefined : json['strength'],
        'dosage_form': !exists(json, 'dosage_form') ? undefined : json['dosage_form'],
        'manufacturer_code': !exists(json, 'manufacturer_code') ? undefined : json['manufacturer_code'],
        'manufacturer_name': !exists(json, 'manufacturer_name') ? undefined : json['manufacturer_name'],
        'individual_price': !exists(json, 'individual_price') ? undefined : json['individual_price'],
        'amount_mohltc_pays': !exists(json, 'amount_mohltc_pays') ? undefined : json['amount_mohltc_pays'],
        'drug_benefit_price': !exists(json, 'drug_benefit_price') ? undefined : json['drug_benefit_price'],
        'coverage_status': !exists(json, 'coverage_status') ? undefined : json['coverage_status'],
        'lcc_id': !exists(json, 'lcc_id') ? undefined : json['lcc_id'],
        'listing_date': !exists(json, 'listing_date') ? undefined : json['listing_date'],
        'category_code': !exists(json, 'category_code') ? undefined : json['category_code'],
        'category_name': !exists(json, 'category_name') ? undefined : json['category_name'],
        'daily_cost': !exists(json, 'daily_cost') ? undefined : json['daily_cost'],
        'not_a_benefit': !exists(json, 'not_a_benefit') ? undefined : json['not_a_benefit'],
        'sec3b': !exists(json, 'sec3b') ? undefined : json['sec3b'],
        'sec3': !exists(json, 'sec3') ? undefined : json['sec3'],
        'sec3b_eap': !exists(json, 'sec3b_eap') ? undefined : json['sec3b_eap'],
        'sec6': !exists(json, 'sec6') ? undefined : json['sec6'],
        'sec12': !exists(json, 'sec12') ? undefined : json['sec12'],
        'din_status': !exists(json, 'din_status') ? undefined : json['din_status'],
        'last_updated': !exists(json, 'last_updated') ? undefined : json['last_updated'],
    };
}

export function OdbFormularyDrugToJSON(value?: OdbFormularyDrug | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'din': value.din,
        'product_name': value.product_name,
        'generic_name': value.generic_name,
        'strength': value.strength,
        'dosage_form': value.dosage_form,
        'manufacturer_code': value.manufacturer_code,
        'manufacturer_name': value.manufacturer_name,
        'individual_price': value.individual_price,
        'amount_mohltc_pays': value.amount_mohltc_pays,
        'drug_benefit_price': value.drug_benefit_price,
        'coverage_status': value.coverage_status,
        'lcc_id': value.lcc_id,
        'listing_date': value.listing_date,
        'category_code': value.category_code,
        'category_name': value.category_name,
        'daily_cost': value.daily_cost,
        'not_a_benefit': value.not_a_benefit,
        'sec3b': value.sec3b,
        'sec3': value.sec3,
        'sec3b_eap': value.sec3b_eap,
        'sec6': value.sec6,
        'sec12': value.sec12,
        'din_status': value.din_status,
        'last_updated': value.last_updated,
    };
}

